import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { TermTime } from './term-time';
export { TermTime };
import { termTimeSchema } from '@schemas/business-objects/term-time';
import { AttendanceFormArray } from './attendance-form-group';
import { SlotFormArray } from './slot-form-group';
import { TermFormGroup } from './term-form-group';

export class TermTimeFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    startTime: SchemaFormControl;
    endTime: SchemaFormControl;
    termId: SchemaFormControl;
    term: TermFormGroup;
    slots: SlotFormArray;
    attendances: AttendanceFormArray;
  };

  declare value: Partial<TermTime>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(termTimeSchema, TermTime, data, options);
  }

  get object(): TermTime {
    return new TermTime(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'term':
        return new TermFormGroup();
      case 'slots':
        return new SlotFormArray();
      case 'attendances':
        return new AttendanceFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<TermTime[]> {
    return TermTime.find(filter);
  }

  static async findOne(filter?: any): Promise<TermTime | null> {
    return TermTime.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<TermTime> {
    return TermTime.findById(id, filter);
  }

  static async create(data: Partial<TermTime>): Promise<TermTime> {
    return TermTime.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<TermTime>,
  ): Promise<TermTime> {
    return TermTime.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return TermTime.deleteById(id);
  }
}

export class TermTimeFormArray extends PersistedFormArray {
  readonly entityName = 'TermTime' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(termTimeSchema, TermTime, options);
  }

  protected override createItemGroup() {
    return new TermTimeFormGroup();
  }

  get array(): TermTime[] {
    return this.controls.map((group: TermTimeFormGroup) => group.object);
  }
}

export class TermTimePersistedArray extends PersistedArray<TermTime> {
  readonly entityName = 'TermTime' as const;

  constructor(options?: PersistedArrayOptions) {
    super(TermTime, options);
  }
}
